module.exports = __webpack_public_path__ + "static/media/archive.1dcfddf2.svg";